import BaseService from './baseService';

class Address extends BaseService {
  async getAddress(opts = {}) {
    this.endPoint = '/address';
    return this.get(opts);
  }
  async createAddress(payload) {
    this.endPoint = '/address';
    return this.post(payload);
  }
  async updateAddress(payload,opts={}){
    this.endPoint = '/address';
    return await this.put(payload,opts); 
  }
  async deleteAddress(id, opts={}) {
    this.endPoint = '/address';
    return await this.delete(id,opts);
  }
}

export default new Address();